export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/wxc-minibar/index.js